import { gql } from "@apollo/client";

export const GET_PROCEEDING_STATUS_HISTORY = gql`
  query ProceedingStatusHistory($input: String) {
    proceedingStatusHistory(input: $input) {
        id
        proceedingNumber
        status
        statusEffectiveDate
        reason
        decisionDate
        decisionNumber
        decisionOutcome
        panelCondition
        otherOutcome
      }
  }
`;

export const UPDATE_PROCEEDING_STATUS = gql`
  mutation UpdateProceedingStatus($input: ProceedingStatusDetail) {
    updateProceedingStatus(input: $input) {
      result
    }
  }
`;


export const GET_PROCEEDING_DETAILS = gql`
  query Proceeding($input: String) {
    proceeding(input: $input) {
      id
      createdDate
      status
    }
  }
`;